"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GlobalModal_component_exports = {};
__export(GlobalModal_component_exports, {
  GlobalModal: () => GlobalModal,
  default: () => GlobalModal_component_default
});
module.exports = __toCommonJS(GlobalModal_component_exports);
var import_react = __toESM(require("react"));
var import_react2 = require("react");
var import_uniqueId = __toESM(require("lodash/uniqueId"));
var import_Helpers = require("../../../utils/Helpers");
var import_headless = require("@tippyjs/react/headless");
var import_Icon = require("../../atoms/Icon/Icon.component");
var import_Button = require("../../atoms/Button/Button.component");
var import_Heading = require("../../atoms/Heading/Heading.component");
var import_react_i18next = require("react-i18next");
var import_useEventListener = require("../../../utils/useEventListener/useEventListener.hook");
var import_GlobalModal = require("./GlobalModal.styled");
var import_i18n = __toESM(require("../../../i18n"));
var _excluded = ["appElement", "hideBars", "visible", "parentSelector", "closeModal", "allowClose", "maxHeight", "shouldReturnFocusAfterClose", "shouldFocusAfterRender", "shouldCloseOnOverlayClick"];
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var modalStyle = {
  content: {},
  overlay: {
    backdropFilter: "blur(8px)",
    WebkitBackdropFilter: "blur(8px)",
    background: "rgba(44, 78, 83, 0.9)",
    overscrollBehavior: "contain",
    overflowY: "hidden",
    transition: "background .3s linear",
    zIndex: "600",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
};
var GlobalModal = function GlobalModal2(_ref) {
  var _ref$appElement = _ref.appElement, appElement = _ref$appElement === void 0 ? "head" : _ref$appElement, _ref$hideBars = _ref.hideBars, hideBars = _ref$hideBars === void 0 ? false : _ref$hideBars, _ref$visible = _ref.visible, visible = _ref$visible === void 0 ? true : _ref$visible, parentSelector = _ref.parentSelector, closeModal = _ref.closeModal, _ref$allowClose = _ref.allowClose, allowClose = _ref$allowClose === void 0 ? true : _ref$allowClose, _ref$maxHeight = _ref.maxHeight, maxHeight = _ref$maxHeight === void 0 ? "80%" : _ref$maxHeight, _ref$shouldReturnFocu = _ref.shouldReturnFocusAfterClose, shouldReturnFocusAfterClose = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, _ref$shouldFocusAfter = _ref.shouldFocusAfterRender, shouldFocusAfterRender = _ref$shouldFocusAfter === void 0 ? true : _ref$shouldFocusAfter, _ref$shouldCloseOnOve = _ref.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _ref$shouldCloseOnOve === void 0 ? true : _ref$shouldCloseOnOve, props = _objectWithoutProperties(_ref, _excluded);
  var modalId = props.id || (0, import_uniqueId.default)();
  var _useState = (0, import_react2.useState)(false), _useState2 = _slicedToArray(_useState, 2), isScrollBarEnabled = _useState2[0], setIsScrollBarEnabled = _useState2[1];
  var _useState3 = (0, import_react2.useState)(false), _useState4 = _slicedToArray(_useState3, 2), isOpen = _useState4[0], setIsOpen = _useState4[1];
  var _useState5 = (0, import_react2.useState)(null), _useState6 = _slicedToArray(_useState5, 2), contentRef = _useState6[0], setContentRef = _useState6[1];
  var _useState7 = (0, import_react2.useState)(null), _useState8 = _slicedToArray(_useState7, 2), windowScrollY = _useState8[0], setWindowScrollY = _useState8[1];
  var _useState9 = (0, import_react2.useState)(false), _useState10 = _slicedToArray(_useState9, 2), closeOnEsc = _useState10[0], setCloseOnEsc = _useState10[1];
  var contentModalRef = (0, import_react2.useRef)(null);
  var _useTranslation = (0, import_react_i18next.useTranslation)(), t = _useTranslation.t;
  var close = function close2() {
    setIsOpen(false);
    if (closeModal) {
      closeModal();
    }
  };
  (0, import_react2.useEffect)(function() {
    if (visible && import_Helpers.hasWindow && import_Helpers.hasDocument) {
      setIsOpen(true);
      setWindowScrollY(window.scrollY);
      window.document.body.style.overflow = "hidden";
    } else {
      close();
    }
  }, [visible]);
  if (props.overlayBackground) {
    modalStyle.overlay.background = props.overlayBackground;
  }
  var modalAria = {
    labelledby: props.ariaLabelledBy || "".concat(modalId, "-modal-title"),
    describedby: props.ariaDescribedBy,
    modal: true,
    live: props["aria-live"]
  };
  var scrollBarEnabled = function scrollBarEnabled2(el) {
    setIsScrollBarEnabled(el.clientHeight < el.scrollHeight);
    contentModalRef.current = el;
  };
  var handleOnAfterOpen = function handleOnAfterOpen2() {
    if (contentRef) {
      var firstFocusableElement = (0, import_Helpers.getFocusableEls)(contentRef)[0];
      if (firstFocusableElement) {
        setTimeout(function() {
          return firstFocusableElement.focus();
        }, 200);
      }
    }
  };
  var handleAfterClose = function handleAfterClose2() {
    window.document.body.style.overflow = "";
    if (windowScrollY) {
      window.scroll(0, windowScrollY);
    }
  };
  var handleContentRef = function handleContentRef2(node) {
    if (node) {
      setContentRef(node);
    }
  };
  var hideBar = function hideBar2() {
    return isScrollBarEnabled ? false : hideBars;
  };
  var closeButton = allowClose ? /* @__PURE__ */ import_react.default.createElement(import_react_i18next.I18nextProvider, {
    i18n: import_i18n.default
  }, /* @__PURE__ */ import_react.default.createElement(import_GlobalModal.StyledButtonContainer, {
    withCustomHeader: !!props.customHeader,
    padding: props.contentPadding
  }, /* @__PURE__ */ import_react.default.createElement(import_Button.Button, {
    onClick: close,
    icon: "x",
    variant: "empty",
    circle: true,
    size: "40px",
    iconSize: 32,
    "aria-label": props.closeButtonAriaLabel ? props.closeButtonAriaLabel : t("base_action_closeModal"),
    "data-testid": "close-modal-button"
  }))) : null;
  var customizableHeader = /* @__PURE__ */ import_react.default.createElement(import_GlobalModal.StyledCustomHeader, {
    "data-testid": "customHeader",
    padding: props.contentPadding,
    id: "".concat(modalId, "-modal-custom-header")
  }, closeButton, props.customHeader);
  var defaultHeader = /* @__PURE__ */ import_react.default.createElement(import_GlobalModal.StyledModalHeader, {
    hideBars: hideBar(),
    "data-testid": "header",
    id: "".concat(modalId, "-modal-header")
  }, props.title && /* @__PURE__ */ import_react.default.createElement(import_GlobalModal.StyledModalTitle, {
    id: "".concat(modalId, "-modal-title"),
    "aria-hidden": true
  }, props.icon && /* @__PURE__ */ import_react.default.createElement(import_Icon.Icon, {
    icon: props.icon,
    size: 26
  }), /* @__PURE__ */ import_react.default.createElement(import_Heading.Heading, {
    level: 2
  }, props.title)), closeButton);
  if (process.env.NODE_ENV !== "test")
    import_GlobalModal.StyledModal.setAppElement(appElement);
  (0, import_useEventListener.useEventListener)("resize", function() {
    if (contentModalRef.current)
      scrollBarEnabled(contentModalRef.current);
  });
  (0, import_react2.useEffect)(function() {
    import_headless.tippy.setDefaultProps({
      // if a tooltip is being displayed the closeOnEsc prop is disabled
      onShow: function onShow() {
        setCloseOnEsc(true);
      },
      onHide: function onHide() {
        setCloseOnEsc(false);
      }
    });
  }, []);
  return /* @__PURE__ */ import_react.default.createElement(import_GlobalModal.StyledModal, {
    aria: modalAria,
    className: props.className,
    overlayClassName: props.overlayClassName,
    style: modalStyle,
    maxHeight,
    maxWidth: props.maxWidth,
    size: props.size,
    isOpen,
    id: modalId,
    onRequestClose: allowClose ? close : null,
    "data-testid": "Modal",
    allowClose,
    shouldReturnFocusAfterClose,
    shouldFocusAfterRender,
    contentRef: handleContentRef,
    onAfterOpen: handleOnAfterOpen,
    onAfterClose: handleAfterClose,
    parentSelector,
    shouldCloseOnOverlayClick,
    shouldCloseOnEsc: !closeOnEsc
  }, props.customHeader ? /* @__PURE__ */ import_react.default.createElement(import_react.default.Fragment, null, customizableHeader) : /* @__PURE__ */ import_react.default.createElement(import_react.default.Fragment, null, defaultHeader), /* @__PURE__ */ import_react.default.createElement(import_GlobalModal.StyledContent, {
    tabIndex: isScrollBarEnabled ? 0 : -1,
    "data-testid": "content",
    padding: props.contentPadding,
    withCustomHeader: !!props.customHeader,
    id: "".concat(modalId, "-modal-content"),
    ref: function ref(el) {
      if (el) {
        scrollBarEnabled(el);
      }
    }
  }, props.children), props.footer && /* @__PURE__ */ import_react.default.createElement(import_GlobalModal.StyledFooter, {
    "data-testid": "footer",
    id: "".concat(modalId, "-modal-footer"),
    hideBars: hideBar()
  }, props.footer));
};
var GlobalModal_component_default = GlobalModal;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  GlobalModal
});
//# sourceMappingURL=GlobalModal.component.js.map